import { Mic, Square, Loader2 } from 'lucide-react';
import { VoiceWaveform } from '../ai/VoiceWaveform';
import { useVoiceRecorder } from './useVoiceRecorder';

export const VoiceAnswerBar = ({ onAudio, busyText, disabled, turnLabel }) => {
    const { isRecording, level, seconds, start, stop } = useVoiceRecorder({ onRecorded: onAudio });
    const busy = Boolean(busyText);

    return (
        <div className="flex flex-col items-center gap-3 rounded-2xl border bg-gradient-to-b from-sky-50/60 to-transparent px-4 py-6 dark:from-sky-950/20" data-testid="eeoc-voice-bar">
            <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground" data-testid="eeoc-turn-label">{turnLabel}</p>
            <div className="relative">
                {isRecording && (
                    <span
                        className="absolute inset-0 rounded-full bg-red-500/25 transition-transform duration-100"
                        style={{ transform: `scale(${1.15 + level * 0.9})` }}
                    />
                )}
                <button
                    type="button"
                    onClick={isRecording ? stop : start}
                    disabled={disabled || busy}
                    className={`relative flex h-20 w-20 items-center justify-center rounded-full text-white shadow-lg transition-[background-color,transform] duration-200 hover:scale-105 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:scale-100 ${
                        isRecording ? 'bg-red-500' : 'bg-gradient-to-br from-sky-500 to-blue-600'
                    }`}
                    aria-label={isRecording ? 'Stop and send answer' : 'Start speaking'}
                    data-testid="eeoc-mic-btn"
                >
                    {busy ? <Loader2 className="h-8 w-8 animate-spin" /> : isRecording ? <Square className="h-7 w-7" /> : <Mic className="h-8 w-8" />}
                </button>
            </div>
            {isRecording ? (
                <div className="flex w-full max-w-xs flex-col items-center gap-2">
                    <VoiceWaveform isRecording={isRecording} audioLevel={level} className="h-8" />
                    <p className="text-sm font-medium text-red-600" data-testid="eeoc-recording-status">
                        Recording · {Math.floor(seconds / 60)}:{String(seconds % 60).padStart(2, '0')} · tap to send
                    </p>
                </div>
            ) : (
                <p className="text-sm text-muted-foreground" data-testid="eeoc-voice-status">
                    {busy ? busyText : 'Tap the mic and speak your reply to the candidate'}
                </p>
            )}
        </div>
    );
};
